import { apiCall } from './gqlClient';

const GETTIMEZONES_QUERY = `
  query getTimezones {
    getTimezones
    {
      id
			timezone
      ...fragments
    }
  }`;

export const getTimezonesApiCall = async (fragments = null) => apiCall({ query: GETTIMEZONES_QUERY, variables: {}, fragments });

const GETPROVIDERTIMEZONE_QUERY = `
  query getProviderTimezone($id: Int) {
    getProviderTimezone(id: $id)
  }`;

export const getProviderTimezoneApiCall = async ({id}, ) => apiCall({ query: GETPROVIDERTIMEZONE_QUERY, variables: {id}});

const GETUSERTIMEZONE_QUERY = `
  query getUserTimezone($id: Int) {
    getUserTimezone(id: $id)
  }`;

export const getUserTimezoneApiCall = async ({id}, ) => apiCall({ query: GETUSERTIMEZONE_QUERY, variables: {id}});

const SAVEUSERTIMEZONE_QUERY = `
  mutation saveUserTimeZone($timezone: String!) {
    saveUserTimeZone(timezone: $timezone)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const saveUserTimeZoneApiCall = async ({timezone}, fragments = null) => apiCall({ query: SAVEUSERTIMEZONE_QUERY, variables: {timezone}, fragments });

const SAVEPROVIDERTIMEZONE_QUERY = `
  mutation saveProviderTimeZone($timezone: String!) {
    saveProviderTimeZone(timezone: $timezone)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const saveProviderTimeZoneApiCall = async ({timezone}, fragments = null) => apiCall({ query: SAVEPROVIDERTIMEZONE_QUERY, variables: {timezone}, fragments });
